import { render, staticRenderFns } from "./ChatItemTopBar.vue?vue&type=template&id=f9dc79f0"
import script from "./ChatItemTopBar.vue?vue&type=script&lang=js"
export * from "./ChatItemTopBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports